(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Affix; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(847);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69777);
/* harmony import */ var _mantine_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79729);
/* harmony import */ var _Portal_OptionalPortal_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21589);
/* harmony import */ var _Box_Box_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14661);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  position: { bottom: 0, right: 0 },
  zIndex: (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultZIndex */ .w)("modal"),
  withinPortal: true
};
const Affix = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_2__/* .useComponentDefaultProps */ .N4)("Affix", defaultProps, props), { target, position, zIndex, sx, withinPortal, portalProps } = _a, others = __objRest(_a, ["target", "position", "zIndex", "sx", "withinPortal", "portalProps"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_OptionalPortal_js__WEBPACK_IMPORTED_MODULE_3__/* .OptionalPortal */ .q, __spreadProps(__spreadValues({}, portalProps), {
    withinPortal,
    target
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box_Box_js__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, __spreadValues({
    sx: [__spreadValues({ position: "fixed", zIndex }, position), ...(0,_mantine_utils__WEBPACK_IMPORTED_MODULE_5__/* .packSx */ .R)(sx)],
    ref
  }, others)));
});
Affix.displayName = "@mantine/core/Affix";


//# sourceMappingURL=Affix.js.map


/***/ }),

/***/ 11427:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(73083);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./src/plugins/crisp/index.ts
var crisp = __webpack_require__(7897);
// EXTERNAL MODULE: ./src/components/site/index.ts + 21 modules
var site = __webpack_require__(24613);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./src/modules/Site/Pricing/index.module.scss
var index_module = __webpack_require__(58825);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/Header/index.tsx





var Header = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* GridBackground */.o9, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
            className: (index_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                align: "center",
                className: (index_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    className: "text-[32px] pt-[124px] pb-[16px] sm:text-[56px] sm:pt-[145px] sm:pb-[70px]",
                    children: "选择合适你的最佳方案"
                })
            })
        })
    });
};
/* harmony default export */ var Pricing_Header = (Header);

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
;// CONCATENATED MODULE: ./src/assets/images/site/avatar/girl11.png
/* harmony default export */ var girl11 = ({"src":"https://static-cny.howxm.com/_next/static/media/girl11.fa7444e5.png","height":200,"width":200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAxElEQVR42mNAB6kq2pww9gb3EiYwY21gKTOI3u1fV3cqovPN4ZCWPbPtU8TBktXiPiwgulszzHy9S9H//fFN/xf75f/f6ljWi2wyo4+26qGGwoz/R5f0fl/YUPi/0TN0A1x2TU9ZVbSD7v9b2xZ9e3po1e+rWxf+Twp2fQqUkgYreHZw+YELa6f8n1YU9X9zT8n/uZXJ/60URP+7GKpWgBU82Dl37u0t01+5aAktsNeU2AwUOmikKHbUUlXKFNkdPAxYAADcS0z6Le/TdwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/modules/Site/Pricing/ContactUs/index.module.scss
var ContactUs_index_module = __webpack_require__(54926);
var ContactUs_index_module_default = /*#__PURE__*/__webpack_require__.n(ContactUs_index_module);
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ContactUs/index.tsx









var ContactUs = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        rootMargin: "0px 0px -200px 0px",
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                className: (ContactUs_index_module_default()).outer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    className: (ContactUs_index_module_default()).wrapper,
                    position: "apart",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: 16,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    className: "w-[60px] h-[60px] sm:w-[100px] sm:h-[100px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        src: girl11.src,
                                        alt: "avatar"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                    spacing: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                                            text: "不知道选择哪个套餐？",
                                            isIntersecting: isIntersecting
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            c: "gray.7",
                                            className: classnames_default()("text-[24px] transformSlideInBottomBase delay-150", {
                                                transformSlideInBottom: isIntersecting
                                            }),
                                            children: "联系客户经理，我们会针对您的业务给予建议"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            radius: "md",
                            size: "lg",
                            className: "self-end sm:w-[270px] w-[254px]",
                            onClick: crisp/* openCrisp */.C,
                            children: "联系客户经理"
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var Pricing_ContactUs = (ContactUs);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Table/Table.js + 1 modules
var Table = __webpack_require__(9654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Affix/Affix.js
var Affix = __webpack_require__(354);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Transition/Transition.js + 3 modules
var Transition = __webpack_require__(49954);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(65180);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/components/business/ProductsModal/Price.tsx
var Price = __webpack_require__(43350);
// EXTERNAL MODULE: ./src/config/constants/products.ts
var products = __webpack_require__(52762);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/ProductIntro.tsx









var ProductIntro = function(param) {
    var product = param.product, priceInterval = param.priceInterval, feature = param.feature;
    var t = (0,useTranslation/* default */.Z)("product").t;
    var router = (0,next_router.useRouter)();
    var code = product.code, name = product.name, prices = product.prices;
    var price = prices.find(function(price) {
        return price.interval === priceInterval;
    });
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var isPaid = code !== products/* ProductCode.Free */.G.Free;
    var handleClick = function() {
        setLoading(true);
        jumpToSignUp();
    };
    var jumpToSignUp = function() {
        var query = isPaid ? {
            productCode: code
        } : {};
        router.push({
            pathname: constants/* Signup */.Al,
            query: query
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        w: 226,
        h: 180,
        px: 16,
        sx: function(theme) {
            return {
                background: isPaid ? "#F6F8F9" : "white",
                border: "1px solid ".concat(isPaid ? "transparent" : "#E3E5E8"),
                borderRadius: 8
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            py: "xl",
            h: 180,
            ta: "center",
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    order: 3,
                    lh: "28px",
                    children: name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                    mt: "auto",
                    spacing: 24,
                    children: price ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                price: price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                fullWidth: true,
                                size: "sm",
                                disabled: loading,
                                onClick: handleClick,
                                children: t("purchaseNow")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                fz: 24,
                                fw: 600,
                                lh: "30px",
                                ta: "center",
                                children: (0,utils/* formatNumberToThousands */.NZ)(0 / 100, {
                                    style: "currency",
                                    currency: "CNY",
                                    point: 0,
                                    currencyDisplay: "narrowSymbol"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "default",
                                fullWidth: true,
                                size: "sm",
                                onClick: jumpToSignUp,
                                children: "免费使用"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductsDetail_ProductIntro = (ProductIntro);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/image.js
var next_image = __webpack_require__(66401);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/components/FeatureTable.tsx




var FeatureTable = function(param) {
    var title = param.title, icon = param.icon, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "sm",
                my: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        w: 24,
                        h: 24,
                        ml: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: icon.src,
                            alt: "platform",
                            width: 24,
                            height: 24
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 3,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.i, {
                horizontalSpacing: 16,
                sx: {
                    "tbody tr:last-of-type td": {
                        borderBottom: "1px solid rgba(227, 229, 232, 0.6)"
                    },
                    "tbody tr td": {
                        padding: "16px 0",
                        fontSize: "16px",
                        borderBottom: "1px solid rgba(227, 229, 232, 0.6)"
                    },
                    "tbody tr td:first-of-type": {
                        paddingLeft: "24px",
                        color: "#495057"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ var components_FeatureTable = (FeatureTable);

;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/images/platform.png
/* harmony default export */ var platform = ({"src":"https://static-cny.howxm.com/_next/static/media/platform.b1223b6c.png","height":46,"width":46,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAqUlEQVR42gXArS6FAQAG4Of9zhnmZ3MLksmComqKoroCmqC7A9FGZaMIik42MpvJCts5M2evZWPvaTccSn5b0/DXWEo7V17H4Ygc4zmxhbW0V1jA+SCZ4Jmit9odQjJN8jKo0WyYpZyqyzKqPmj31WQoP6MOm6kDLIvrBHw2hkHMqzdsl/dwj7smj1gdp11k+JZ+hRvtujijMDfGC71Qr3SRfFRP0qzQrX804UqS1FQW9gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconCheck.js
var IconCheck = __webpack_require__(7861);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/components/ValueCell.tsx




var ValueCell = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
        className: "text-center",
        children: children
    });
};
var Cell = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
        width: "226",
        className: className,
        children: children
    });
};
var CheckCell = function() {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
            color: theme.colors.brandBlue[7],
            size: 24
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/Platform.tsx





var Platform = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeatureTable, {
        title: "平台能力",
        icon: platform,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "应用创建数量"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "2个"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "5个"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "10个"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "20个"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "X-SDK 代码集成"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "Web/H5/网站支持"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "APP/小程序支持"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "团队协作账户"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "10个/应用"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "20个/应用"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "50个/应用"
                        })
                    ]
                }),
                [
                    "用户群组",
                    "推送至企业微信、钉钉、飞书",
                    "Webhook 与数据 API"
                ].map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                                children: item
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                        ]
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "隐藏浩客品牌标识"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ProductsDetail_Platform = (Platform);

;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/images/campaign.png
/* harmony default export */ var campaign = ({"src":"https://static-cny.howxm.com/_next/static/media/campaign.1dc5fe64.png","height":48,"width":46,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAr0lEQVR42k2OMQrCQBBFB8VOLETsbYTdygNobWUxewEbjxAQS/EAgo2Qxl6NSpAUHsDdHCG3yYNkIQPL/v/mz+yKUa9WfWFduKMfVkOGzmA5/iyIH3AulHFhaPTfl7YI3IT0xzg/aBm+HMFOjQ6JkPoaLXvW+SXgwHmxcdtsCEcB5HGaTSnNTfToJP5hTXrceXuCn9F7C6sXgAvTT/See4UvCFzxO+kWIOVUTE4jqwHxk06MOS5gGAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/Campaign.tsx





var Campaign_Platform = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeatureTable, {
        title: "评价&问卷",
        icon: campaign,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "创建量"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "3 份"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "不限量"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "不限量"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "不限量"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "总数据量"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "3000条/年"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "10万条/年"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "50万条/年"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {
                            children: "100万条/年"
                        })
                    ]
                }),
                [
                    "一页多题",
                    "引导(CTA) 字段",
                    "贴边按钮/弹框展现",
                    "自定义主题样式",
                    "问卷场景模板",
                    "字段显隐/跳转规则",
                    "基础投放规则",
                    "免打扰机制",
                    "用户身份传递",
                    "基础数据报表",
                    "多语言问卷", 
                ].map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                                children: item
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                        ]
                    }, index);
                }),
                [
                    "在线截图",
                    "指定投放时间",
                    "精准用户投放",
                    "事件触发投放"
                ].map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                                children: item
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var Campaign = (Campaign_Platform);

;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/images/service.png
/* harmony default export */ var service = ({"src":"https://static-cny.howxm.com/_next/static/media/service.187245a9.png","height":46,"width":46,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAuElEQVR42i2OMQoCMRBFBxQUj2ApWCR23sBekOQAtoIWFlZbbGGhIOwJLCxWC0ERdFOIsnVyrH1Z8uGTmfn/Z0aU8XNt/E/bUGnrK3qnbPjEGXUhrWjCRACDrgBmndTfhOQ7NRl8IV5577CHto2GMq6BF2X9EMOUeqlM2KOtouHBYAwdHAjgljPGBbdshJRLe2cY/gSeGE4CMOQI4Qv76Y6RZp0kED7EZIGhhBnpHak1P+T0R2183QDjUl2U8aSTlQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/Service.tsx





var Service = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeatureTable, {
        title: "服务支持",
        icon: service,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "在线客服"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "1v1客户成功经理"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "1v1技术客服支持"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell, {
                            children: "产品远程培训1次"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueCell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCell, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ProductsDetail_Service = (Service);

;// CONCATENATED MODULE: ./src/modules/Site/Pricing/ProductsDetail/index.tsx










var ProductsDetail_Header = function(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* Table */.i, {
        horizontalSpacing: 16,
        sx: {
            "tbody tr td": {
                padding: 0
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        width: "226"
                    }),
                    products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            width: "226",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail_ProductIntro, {
                                product: product,
                                priceInterval: domain/* PriceInterval.Year */.pjJ.Year
                            })
                        }, product.code);
                    })
                ]
            })
        })
    });
};
var ProductDetail = function(param) {
    var products = param.products;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 1), scroll = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        w: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Affix/* Affix */.D, {
                position: {
                    top: "57px"
                },
                zIndex: 1002,
                className: "hidden sm:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* Transition */.u, {
                    transition: "fade",
                    mounted: scroll.y > 1600,
                    children: function(transitionStyles) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                            bg: "white",
                            w: "calc(100vw - 10px)",
                            h: 200,
                            opacity: 0.8,
                            className: "border-0 border-b border-solid border-gray-2 backdrop-blur",
                            style: transitionStyles,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                w: 1194,
                                spacing: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail_Header, {
                                    products: products
                                })
                            })
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail_Header, {
                products: products
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                mt: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 30,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail_Platform, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Campaign, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail_Service, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ProductsDetail = (ProductDetail);

;// CONCATENATED MODULE: ./src/modules/Site/Pricing/FeatureCompare/index.tsx






var FeatureCompare = function(param) {
    var className = param.className, products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ContentIntoView */.xJ, {
        rootMargin: "0px 0px -200px 0px",
        className: className,
        children: function(entry) {
            var isIntersecting = (entry || {}).isIntersecting;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* ContentContainer */.OO, {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 48,
                    className: "max-w-[1194px] w-full",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteTitle */.JL, {
                            text: "比较所有功能",
                            isIntersecting: isIntersecting
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsDetail, {
                            products: products
                        })
                    ]
                })
            });
        }
    });
};
/* harmony default export */ var Pricing_FeatureCompare = (FeatureCompare);

// EXTERNAL MODULE: ./src/components/business/ProductsModal/index.ts + 13 modules
var ProductsModal = __webpack_require__(7921);
;// CONCATENATED MODULE: ./src/modules/Site/Pricing/index.tsx








var Pricing = function(param) {
    var products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        className: "overflow-x-hidden xs:overflow-x-visible pt-[0]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "mt-[-356px] sm:mt-[-170px] sm:max-w-[1200px] m-[unset] sm:m-[auto]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal/* ProductsModalContent */.Ul, {
                    fromSite: true,
                    products: products
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                className: "hidden sm:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_ContactUs, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing_FeatureCompare, {
                        products: products
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* FooterWrapper */.V6, {
                className: "pt-[96px] !bg-[center_top_-40px]"
            })
        ]
    });
};
/* harmony default export */ var Site_Pricing = (Pricing);

;// CONCATENATED MODULE: ./src/pages/pricing.tsx






var pricingTitle = "价格套餐 - 浩客HowXM官网 - 数字化系统必备的应用内调研、评价、通知工具，支持免费试用";
var _prices, _unitAmount;
var buildProductSchema = function(products) {
    return products.map(function(product) {
        return {
            "@context": "https://schema.org",
            "@type": "Product",
            name: "浩客HowXM ".concat(product.name),
            brand: {
                "@type": "Brand",
                name: "浩客HowXM"
            },
            offers: ((_prices = product.prices) !== null && _prices !== void 0 ? _prices : []).map(function(price) {
                return {
                    "@type": "Offer",
                    priceCurrency: "CNY",
                    price: ((_unitAmount = price.unitAmount) !== null && _unitAmount !== void 0 ? _unitAmount : 0) / 100,
                    url: "".concat(constants/* brandingUrl */.$t, "/pricing")
                };
            })
        };
    });
};
function pricing_Price(param) {
    var products = param.products;
    (0,crisp/* useCrisp */.L)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(site/* SiteLayout */.Iv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* SiteSEO */.EI, {
                title: pricingTitle,
                description: "浩客HowXM 提供免费套餐与多档付费套餐，支持免费注册试用。在 Web、App、小程序中嵌入问卷、NPS 调研与通知，按需选择适合团队的体验管理方案。"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site/* StructuredData */.Jr, {
                data: buildProductSchema(products)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Site_Pricing, {
                products: products
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var pricing = (pricing_Price);


/***/ }),

/***/ 54926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactUs_wrapper___Qf0h","outer":"ContactUs_outer__p2ekq"};

/***/ }),

/***/ 58825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pricing_wrapper__11zkv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2525,3703,8329,1958,4476,7094,1404,3226,9774,2888,179], function() { return __webpack_exec__(11427); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);